export const propertiesObject = {
  oeeTimeDown: null,
  oeeUnitsBad: null,
  oeeUnitsGood: null,
  oeeUnitsTotal: null,
  oeeTimeIdealCycle: null,
  oeeTimeOperating: null,
  oeeTimeAvailableAll: null,
};

export const sampleMessage = {
  oeeUnitsGood: "an integer, greater than or equal to zero",
  oeeUnitsBad: "an integer, greater than or equal to zero",
  oeeUnitsTotal: "an integer, greater than or equal to zero",
  oeeTimeIdealCycle: "an integer, units are seconds, greater than or equal to zero,",
  oeeTimeAvailableAll: "an integer, units are minutes, equal to 1440",
  oeeTimeOperating: "an integer, units are minutes, greater than or equal to zero",
  oeeTimeDown: "an integer, units are minutes, greater than or equal to zero",
};
